import AuthPlugin from '@/auth/plugin';
import VueCompositionApi from '@vue/composition-api';
import moment from 'moment';
import PortalVue from 'portal-vue';
import SuiVue from 'semantic-ui-vue';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueConfirmDialog from 'vue-confirm-dialog';
import VueToastr from 'vue-toastr';

import { api } from './api';
import App from './App.vue';
import i18n from './i18n';
import router from './router';
import store from './store';

moment.locale('fr');

Vue.config.productionTip = false

Vue.use(VueCompositionApi);
Vue.use(SuiVue);
Vue.use(PortalVue);
Vue.use(VueToastr, {
    defaultPosition: 'toast-bottom-right',
});
Vue.use(VueConfirmDialog);
Vue.use(VueClipboard);
Vue.use(AuthPlugin, {
    authUrl: process.env.VUE_APP_AUTH_ISSUER_URL,
    clientId: 'vmlive_monitoring',
    redirectPath: 'auth-callback',
    onToken(token) {
        api.setToken(token);
    },
    onLogout() {
        api.setToken(null);
    },
});

export const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

router.onReady(() => {
    const publicRoutes = ['Login', 'AuthCallback', 'AuthAuto'];
    const currentRoute = router.currentRoute;

    if (!app.$auth.isLogged.value) {
        if (!publicRoutes.includes(currentRoute.name)) {
            router.replace({ name: 'Login', query: { from: currentRoute.fullPath } });
        }
        return;
    }
});